import React from "react";
import { VariantProps } from ".";
import PlusShippingLevels from "../PlusShippingLevels";
import GoogleViewPrice from "../GoogleViewPrice";
import StandardPrice from "../StandardPrice";
const Z = ({
  hasFreeShipping,
  hasWebPlusDiscountedShipping,
  price,
  isGoogleView,
  minimumBuy,
  mustBuy,
  unitOfMeasure,
  isWebstaurantPlusEligible
}: VariantProps) => {
  return <>
      <label>Each Only</label>
      {isGoogleView ? <GoogleViewPrice price={price.price} minimumBuy={minimumBuy} mustBuy={mustBuy} /> : <StandardPrice price={price.price} unitOfMeasure={unitOfMeasure} />}
      <PlusShippingLevels hasFreeShipping={hasFreeShipping} hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} data-sentry-element="PlusShippingLevels" data-sentry-source-file="Z.tsx" />
    </>;
};
export default Z;